<template>
  <div>
    <FormCheckbox
      v-for="(option, index) in options"
      :class="mbClass"
      :key="option"
      :option="option"
      :name="`${name}-${index}`"
      :use-value="useValue"
      :checkbox-size="checkboxSize"
      :custom-accent-hex="customAccentHex"
      :checkbox-container-classes="checkboxContainerClasses"
      :items-center="itemsCenter"
      :text-class="textClass"
      :model-value="modelValue && modelValue.includes(useValue ? option.value : option)"
      :readonly="readonly"
      @update:modelValue="toggle(option)"
    >
      {{ useValue ? option.label : option }}
    </FormCheckbox>
    <InfiniteScrollTrigger @trigger="handleGetMoreResults"/>
  </div>
</template>

<script setup>
import FormCheckbox from "./FormCheckbox.vue";
import InfiniteScrollTrigger from "./InfiniteScrollTrigger.vue";

const emits = defineEmits(["update:modelValue", "load-next-page"]);
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Array,
    default: () => [],
  },
  name: String,
  hideOptionList: Boolean,
  useValue: Boolean,
  checkboxSize: String,
  checkboxContainerClasses: String,
  itemsCenter: Boolean,
  textClass: String,
  customAccentHex: String,
  mbClass: {
    type: String,
    default: "mb-1",
  },
  readonly: Boolean,
});

const toggle = (option) => {
  const optionVal = props.useValue ? option.value : option;
  const index = props.modelValue.indexOf(optionVal);
  if (index === -1) {
    updateModelValue([...props.modelValue, optionVal]);
  } else {
    updateModelValue(props.modelValue.filter((item) => item !== optionVal));
  }
};

const updateModelValue = (value) => emits("update:modelValue", value);

const handleGetMoreResults = () => {
  if (props.options.length) emits("load-next-page");
};
</script>
